export function getWriteKey() {
    let fromNode;
    try {
        fromNode = process.env.NEXT_PUBLIC_RUDDER_WRITE_KEY;
    }
    catch {
        fromNode = undefined;
    }
    let fromVite;
    try {
        fromVite = import.meta.env.VITE_RUDDER_WRITE_KEY;
    }
    catch {
        fromVite = undefined;
    }
    return fromNode ?? fromVite;
}
